import { queryClient } from "../react-query-conf";

export const updateDependencies = (dependencyArray: string[]) => {
  dependencyArray.forEach(dependency => {
    queryClient.invalidateQueries(dependency);
  });
};
